/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type poshmarkBotOfferToLikersEvidenceLogsQueryVariables = {
  offerConfigId?: string | null;
  cursor?: string | null;
  limit?: number | null;
};
export type poshmarkBotOfferToLikersEvidenceLogsQueryResponse = {
  readonly poshmarkBotOfferToLikersEvidenceLogs: {
    readonly items: ReadonlyArray<{
      readonly listing: {
        readonly id: string;
        readonly url: string | null;
        readonly thumbnail: string | null;
        readonly title: string;
        readonly currentPrice: number | null;
        readonly deleted: boolean;
        readonly sold: boolean;
      } | null;
      readonly failurePublicReason: string | null;
      readonly listingUrl: string | null;
      readonly listingId: string;
      readonly createdAt: number;
    }>;
    readonly cursor: string | null;
  } | null;
};
export type poshmarkBotOfferToLikersEvidenceLogsQuery = {
  readonly response: poshmarkBotOfferToLikersEvidenceLogsQueryResponse;
  readonly variables: poshmarkBotOfferToLikersEvidenceLogsQueryVariables;
};

/*
query poshmarkBotOfferToLikersEvidenceLogsQuery(
  $offerConfigId: String
  $cursor: String
  $limit: Int
) {
  poshmarkBotOfferToLikersEvidenceLogs(offerConfigId: $offerConfigId, cursor: $cursor, limit: $limit) {
    items {
      listing {
        id
        url
        thumbnail
        title
        currentPrice
        deleted
        sold
      }
      failurePublicReason
      listingUrl
      listingId
      createdAt
    }
    cursor
  }
}
*/

const node: ConcreteRequest = (function () {
  var v0 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'cursor',
    },
    v1 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'limit',
    },
    v2 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'offerConfigId',
    },
    v3 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'cursor',
            variableName: 'cursor',
          },
          {
            kind: 'Variable',
            name: 'limit',
            variableName: 'limit',
          },
          {
            kind: 'Variable',
            name: 'offerConfigId',
            variableName: 'offerConfigId',
          },
        ],
        concreteType: 'PoshmarkBotOfferToLikersEvidenceLogPage',
        kind: 'LinkedField',
        name: 'poshmarkBotOfferToLikersEvidenceLogs',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: 'PoshmarkBotOfferToLikersEvidenceLog',
            kind: 'LinkedField',
            name: 'items',
            plural: true,
            selections: [
              {
                alias: null,
                args: null,
                concreteType: 'PoshmarkBotListing',
                kind: 'LinkedField',
                name: 'listing',
                plural: false,
                selections: [
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'id',
                    storageKey: null,
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'url',
                    storageKey: null,
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'thumbnail',
                    storageKey: null,
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'title',
                    storageKey: null,
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'currentPrice',
                    storageKey: null,
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'deleted',
                    storageKey: null,
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'sold',
                    storageKey: null,
                  },
                ],
                storageKey: null,
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'failurePublicReason',
                storageKey: null,
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'listingUrl',
                storageKey: null,
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'listingId',
                storageKey: null,
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'createdAt',
                storageKey: null,
              },
            ],
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'cursor',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/],
      kind: 'Fragment',
      metadata: null,
      name: 'poshmarkBotOfferToLikersEvidenceLogsQuery',
      selections: v3 /*: any*/,
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [v2 /*: any*/, v0 /*: any*/, v1 /*: any*/],
      kind: 'Operation',
      name: 'poshmarkBotOfferToLikersEvidenceLogsQuery',
      selections: v3 /*: any*/,
    },
    params: {
      cacheID: 'ad3917bfaa88877fac96f21d41930e53',
      id: null,
      metadata: {},
      name: 'poshmarkBotOfferToLikersEvidenceLogsQuery',
      operationKind: 'query',
      text: 'query poshmarkBotOfferToLikersEvidenceLogsQuery(\n  $offerConfigId: String\n  $cursor: String\n  $limit: Int\n) {\n  poshmarkBotOfferToLikersEvidenceLogs(offerConfigId: $offerConfigId, cursor: $cursor, limit: $limit) {\n    items {\n      listing {\n        id\n        url\n        thumbnail\n        title\n        currentPrice\n        deleted\n        sold\n      }\n      failurePublicReason\n      listingUrl\n      listingId\n      createdAt\n    }\n    cursor\n  }\n}\n',
    },
  };
})();
(node as any).hash = '40cf1dfdde4c7f0675a80dc68a07cfa5';
export default node;
